import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';
import { ModalHeaderDefault } from '@/shared/ui/modal';

type RemoveMemberModalProps = {
  isLoading?: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onRemove: () => void;
};

export const RemoveMemberModal = ({ isLoading, isOpen, onCancel, onRemove }: RemoveMemberModalProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Modal open={isOpen} size="xs" onClose={onCancel}>
      <ModalHeaderDefault
        title={t('teamspace.member.remove.title')}
        subtitle={t('teamspace.member.remove.subtitle')}
        onClose={onCancel}
      />

      <ModalActions>
        <Button
          data-testid="teamspace-cancel-remove-member"
          disabled={isLoading}
          variant="outlined"
          fullWidth
          onClick={onCancel}
        >
          {t('teamspace.action.cancel')}
        </Button>
        <Button
          data-testid="teamspace-confirm-remove-member"
          isLoading={isLoading}
          variant="error"
          fullWidth
          onClick={onRemove}
        >
          {t('teamspace.action.remove')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
